<template>
  <div class="omain">
    <div class="numInfoBox">
      <div class="boxOpt">
        <!-- 商品数量 -->
        <p class="optTitle">{{ $fanyi("商品数量") }}:</p>
        <p class="optNum">{{ parentData.Count }}</p>
      </div>
      <div class="hr"></div>
      <div class="boxOpt">
        <!-- 小计 -->
        <p class="optTitle">{{ $fanyi("小计") }}:</p>
        <p class="optNum">
          <span class="price"
            ><b
              >{{
                $fun.EURNumSegmentation(
                  isNaN(parentData.money)
                    ? ""
                    : $fun.ceil(parentData.money * $store.state.exchangeRate)
                )
              }}€</b
            >

            <span>
              ({{
                $fun.RMBNumSegmentation(
                  !isNaN(parentData.money) ? parentData.money.toFixed(2) : ""
                )
              }}￥)</span
            ></span
          >
        </p>
      </div>
      <div class="hr"></div>
      <button
        @click="parentData.addCart(false)"
        ref="start"
        class="start"
        id="start"
        :disabled="parentData.isAddCart"
      >
        <img alt="" id="addCart" />
        {{ $fanyi("加入购物车") }}
      </button>
    </div>
    <div class="otherInformation">
      <div class="promptText">
        {{ $fanyi("如果您想购买和发送此产品的样品，请联系专家代理。") }}
      </div>
      <button class="contactUs bgBlueBtn" @click="$fun.chat(1)">
        {{ $fanyi("与代理交谈") }}
      </button>
      <div class="hr"></div>
      <div class="piFa">
        <span>
          {{ $fanyi("Rakumart是一个批发进口平台，不提供零售服务。") }}</span
        >
      </div>
      <div class="hr"></div>
      <div class="downGoodsImgBox flex fdcolmun">
        <div class="downBoxTit">
          {{ $fanyi("下载图片") }}
        </div>
        <div class="downBoxCon">{{ $fanyi("下载所有的产品图片") }}</div>
        <el-button
          type="primary"
          class="bgYellowBtn downBoxBtn "
          @click="downLoadAllPic"
          >{{ $fanyi("下载") }}
          <img
            class="downBoxImg"
            :src="require('@/assets/icon/product-download.svg')"
            alt=""
          />
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import JSZip from "jszip";
import FileSaver from "file-saver"; //saveAs用到了这个引入
import md5 from "js-md5";

export default {
  data() {
    return {};
  },
  components: {},
  computed: {
    parentData() {
      return this.$parent;
    },
  },
  created() {},
  methods: {
    downLoadAllPic() {
      let box = document.getElementById("introductionOfGoods");
      let dom = document.createElement("div");
      dom.innerHTML = JSON.parse(
        JSON.stringify(this.$parent.details.description)
      );
      let imgArr = dom.getElementsByTagName("img");
      let srcarr = [];
      for (let i = 0; i < imgArr.length; i++) {
        srcarr.push(imgArr[i].src);
      }
      console.log(imgArr, srcarr);
      this.fileArray = [...this.$parent.details.images, ...srcarr];

      (async () => {
        // 初始化一个zip打包对象
        const zip = new JSZip();

        // 创建一个名为录音文件的新的文件目录
        const folder = zip.folder(
          `Productos ${this.$route.query.goods_id}.zip`
        );
        for (let i = 0; i < this.fileArray.length; i++) {
          const blob = await fetch(this.fileArray[i]).then((response) =>
            response.blob()
          );

          // 文件夹添加资源，图片也支持base64类型 {base64: true}
          folder.file(
            this.fileArray[i].substring(this.fileArray[i].lastIndexOf("/") + 1),
            blob,
            { Blob: true }
          );
        }
        // 请求远程资源的blob，其他文件，比如视频、表格等也是一样的

        // 把打包内容异步转成blob二进制格式
        zip.generateAsync({ type: "blob" }).then((content) => {
          // 下载压缩包
          saveAs(content, `Productos ${this.$route.query.goods_id}.zip`);
        });
      })();
    },

    chat(chat) {
      if (this.$store.state.userInfo) {
        let iTop = (window.screen.availHeight - 30 - 700) / 2;
        //获得窗口的水平位置
        let iLeft = (window.screen.availWidth - 10 - 1260) / 2;
        if (chat == 1) {
          // user 传 user_id 的 MD5；商品详情页额外带 url 参数
          const userId = this.$store.state.userInfo.user_id;
          const userIdMd5 = md5(String(userId || ""));
          window.open(
            `https://chat.rakumart.it/#/?id=${userId}&user=${userIdMd5}${
              location.href.indexOf("ProductDetails") != -1
                ? "&url=" + location.href
                : ""
            }`,
            this.$store.state.userInfo,
            "height=700, width=1260, left=" +
              iLeft +
              ", top=" +
              iTop +
              ", toolbar=no, menubar=no, scrollbars=yes, resizable=no, location=no, status=no"
          );
        } else {
          window.open(
            this.chatLink ? this.chatLink : "https://wa.me/+393762669726",
            "WhatsApp",
            "height=700, width=1260, left=" +
              iLeft +
              ", top=" +
              iTop +
              ", toolbar=no, menubar=no, scrollbars=yes, resizable=yes, location=no, status=no"
          );
        }
      } else {
        this.$store.commit(
          "getshowLoginDialog",
          !this.$store.state.showLoginDialog
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
.omain {
  .numInfoBox {
    width: 250px;
    background: #ffffff;
    border: 1px solid #e9e9e9;
    border-radius: 5px;
    padding: 0px 20px 20px;
    .hr {
      background-color: #6d6d6d;
      height: 0.4px;
    }
    .boxOpt {
      text-align: right;
      height: 75px;

      display: flex;
      justify-content: center;
      align-items: flex-end;
      flex-direction: column;
      .optTitle {
        color: #747474;
        font-size: 14px;
        margin-bottom: 5px;
      }
      .optNum {
        font-size: 15px;
        font-weight: 600;
        .price {
          font-size: 14px;
          color: #f1a53d;
          b {
            font-size: 20px;
          }
        }
      }
    }
  }
  .otherInformation {
    width: 233px;
    margin-left: auto;
    .promptText {
      font-size: 12px;
      line-height: 16px;
      margin-top: 14px;
    }
    .contactUs {
      margin-top: 12px;
      width: 234px;
      height: 36px;
      border-radius: 18px;
      display: flex;
      justify-content: center;
      font-weight: normal;
      align-items: center;
      font-size: 12px;
      transition: 0.3s;
      overflow: hidden;
      &:hover {
        background-color: #009246;
        color: white;
      }
      img {
        display: none;
        width: 100%;
        height: 41px;
      }
    }
    .hr {
      background-color: #929191;
      height: 0.5px;
      width: 100%;
      margin: 20px 0;
    }
    .piFa {
      display: flex;
      align-items: flex-start;
      img {
        width: 21px;
        height: 21px;
        margin-right: 5px;
      }
      span {
        font-size: 12px;
      }
    }
  }
}
.start {
  width: 211px;
  height: 50px;
  background: #2a6418;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  display: block;
  margin-top: 20px;
  color: #fff;
  overflow: hidden;
  img {
    display: none;
    width: 100%;
    height: 100%;
  }
  &:hover {
    opacity: 0.7;
  }
}
.downGoodsImgBox {
  min-height: 126px;
  padding: 12px 16px;
  background-color: white;
  border-radius: 8px;
  font-size: 14px;
  .downBoxTit {
    font-weight: 700;
    line-height: 20px; /* 142.857% */
  }
  .downBoxCon {
    font-size: 12px;
    font-weight: 400;
    line-height: 18px; /* 150% */
  }
  .downBoxBtn {
    width: 100%;
    height: 36px;
    line-height: 1;
    margin-top: auto;
    padding: 0;
    /deep/ span {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 700;
      img.downBoxImg {
        margin-left: 4px;
        width: 18px;
        height: 18px;
        display: block;
      }
    }
  }
}
</style>
